import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ApplylistPage } from './applylist';

@NgModule({
  declarations: [
    ApplylistPage,
  ],
  imports: [
    IonicPageModule.forChild(ApplylistPage),
  ],
})
export class ApplylistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/applylist/applylist.module.ts